export default {
    getOriginalContractor: state => state.originalContractor,
}
